import React, { useState, useEffect } from "react";
import { Button, TextField, CircularProgress, Fade} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
// data
import { CreateLoanRequest } from "./createLoanRequest-api";
//auth
import auth from "../../auth/auth-helper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
}));

export default function Transactions() {
  var classes = useStyles();
  var [isLoading, setIsLoading] = useState(false);
  var [msg, setMsg] = useState(null);
  const [amount, setAmount] = useState([]);
  const [branchId, setBranchId] = useState([11]);
  const [accountNo, setAccountNo] = useState([]);
  const [time_period, setTime_period] = useState([]);

  const clickSubmit = () => {
    setIsLoading(true);
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    const loan = {
      amount: amount,
      branch_id: 11,
      fd_no: accountNo,
      time_period: time_period,
      loan_type: 1,
    };

    CreateLoanRequest(signal, credentials, loan).then((res) => {
      setIsLoading(false);
      if (res.status === 200) {
        console.log("token here ....................." + credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setMsg(res.response);
      } else {
        setMsg(res.response);
      }
    });
  };

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          label="Account No"
          value={accountNo}
          onChange={(e) => setAccountNo(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Time Period"
          value={time_period}
          onChange={(e) => setTime_period(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <div className={classes.creatingButtonContainer}>
          {isLoading ? (
            <CircularProgress size={26} />
          ) : (
            <Button
              disabled={
                accountNo.length === 0 ||
                amount.length === 0 ||
                branchId.length === 0 ||
                time_period.length === 0
              }
              variant="contained"
              color="primary"
              onClick={clickSubmit}
            >
              Continue
            </Button>
          )}
        </div>
        <Fade in={msg}>
          <Alert severity="info">
            <AlertTitle>Status</AlertTitle>
            {msg} <strong>check it out!</strong>
          </Alert>
        </Fade>
      </div>
    </form>
  );
}
